// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-btns{display:flex;flex-direction:row;justify-content:flex-end;margin-bottom:17px}.action-btns .submit-button{background-color:#147af3;border-color:#147af3;font-size:14px;border:1px solid transparent;color:#fff;margin-left:16px;padding:12px 37px 35px 37px}@media(min-width:1366px){.action-btns .submit-button{font-size:16px}}.delete-btn{border:0;background-color:transparent;padding:0 14px 0 0;color:#222}.delete-btn,.submit-btn{font-size:16px}", ""]);
// Exports
module.exports = exports;
